module.exports = __webpack_public_path__ + "img/hospital.35c10ab7.png";